module.exports = __webpack_public_path__ + "img/direction-ltr.041f56d6.svg";